import React from 'react';
import { Shield } from 'lucide-react';
import { CredentialsManager } from '../../datasources/components/ApiRest/CredentialsManager';

const CredentialsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-900">
      <div className="container mx-auto px-6 py-8 max-w-7xl">
        {/* Header Mejorado */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-3">
            <div className="p-3 bg-blue-500/10 rounded-lg">
              <Shield className="w-8 h-8 text-blue-400" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-white">
                Gestión de Credenciales API
              </h1>
              <p className="text-slate-400 mt-1">
                Administra las credenciales de autenticación para APIs privadas de forma segura
              </p>
            </div>
          </div>
        </div>

        {/* Manager Component */}
        <CredentialsManager mode="manage" />
      </div>
    </div>
  );
};

export default CredentialsPage;
